export function microfishify(url, size) {
    if (process.env.DEV) {
        return url;
    }

    let src = encodeURIComponent(url),
        w = size.width,
        h = size.height;
    return `https://thumbs.apts247.info/resize/?img=${src}&w=${w}&h=${h}`;
};

export function Size(x, y) {
    this.resize(x, y);
}

Size.prototype.width = 0;
Size.prototype.height = 0;

Size.prototype.copy = function() {
    return new Size(this.width, this.height);
};

Size.prototype.resize = function(x, y) {
    this.width = x;
    this.height = y;

    return this;
};

Size.prototype.resizeX = function(x, proportional = true) {
    let height = this.height;

    if (proportional) {
        height = Math.round(x / (this.width / height));
    }

    return this.resize(x, height);
};

Size.prototype.resizeY = function(y, proportional = true) {
    let width = this.width;

    if (proportional) {
        width = Math.round(y / (this.height / width));
    }

    return this.resize(width, y);
};
